// extracted by mini-css-extract-plugin
var _1 = "NewsboardPostProfileTabComments-modulecomments__PmYYL";
export { _1 as "comments" }
